'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var toggleColor = '#4a4a4a';
if(navigator.language && navigator.language == 'zh-CN'){
    toggleColor = '#007b8a';
}
exports['default'] = {
    tree: {
        base: {
            listStyle: 'none',
            backgroundColor: '#FFFFFF',
            margin: 0,
            padding: 0,
            color: '#4a4a4a',
            fontFamily: "Montserrat, 'Helvetica Neue', Helvetica, Arial, sans-serif",
            fontSize: '14px',
            fontWeight: '400',
            paddingBottom: '20px'
        },
        node: {
            base: {
                position: 'relative'
            },
            link: {
                cursor: 'pointer',
                position: 'relative',
                padding: '5px 5px 5px 12px',
                display: 'block'
            },
            activeLink: {
                background: '#f0f4ff',
                color: '#5A7E9E',
                fontWeight: '600',
                borderRight: 'solid 4px #5A7E9E',
            },
            toggle: {
                base: {
                    position: 'relative',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    marginLeft: '-5px',
                    height: '24px',
                    width: '24px',
                    color: toggleColor,
                    //marginRight:"8px"
                },
                wrapper: {
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    margin: '-5px 0 0 -5px',
                    height: '10px'
                },
                height: 10,
                width: 10,
                arrow: {
                    fill: '#4a4a4a',
                    strokeWidth: 0
                }
            },
            header: {
                base: {
                    display: 'inline-block',
                    verticalAlign: 'top'
                },
                connector: {
                    width: '2px',
                    height: '12px',
                    borderLeft: 'solid 2px black',
                    borderBottom: 'solid 2px black',
                    position: 'absolute',
                    top: '0px',
                    left: '-21px'
                },
                title: {
                    lineHeight: '24px',
                    verticalAlign: 'middle'
                }
            },
            subtree: {
                listStyle: 'none',
                paddingLeft: '32px'
            },
            loading: {
                color: '#555257'
            }
        }
    }
};
module.exports = exports['default'];
